import React from "react";
import { Modal, Box, Typography, List, ListItem, ListItemText, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export interface HotelFareScopeStatus {
  hash: string;
  suppliers: {
    supplierName: string;
    accessCode: string;
    hotelCode: string;
    recievied: boolean;
  }[];
}

interface HotelFareModalProps {
  open: boolean;
  onClose: () => void;
  scope: HotelFareScopeStatus;
}

export const HotelPropertyFareScopeStatus: React.FC<HotelFareModalProps> = ({ open, onClose, scope }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Hotel Fare Scope</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          Hash: {scope.hash}
        </Typography>
        <List>
          {scope.suppliers.map((supplier, index) => (
            <ListItem key={index} divider>
              <ListItemText
                primary={supplier.supplierName}
                secondary={`hotel code: ${supplier.hotelCode}`}
              />
              {supplier.recievied ? (
                <CheckCircleIcon color="success" />
              ) : (
                <CancelIcon color="error" />
              )}
            </ListItem>
          ))}
        </List>
      </Box>
    </Modal>
  );
};
